import {apiService} from "@/services/apiService";
import {API_BASE_URL, DEFAULT_ERROR_MESSAGE} from "@/constants";

async function prepareApiError(response) {
    let errorMessage = null;
    const errorData = await response.json().catch(() => ({}));
    if (errorData.error?.message) {
        // контролируемый ответ от api, доступ к диалогу, неподтвержден email
        errorMessage = errorData.error.message;
    } else if (errorData.message) {
        // валидация
        errorMessage = errorData.message;
    } else {
        // nginx и другие ошибки
        errorMessage = DEFAULT_ERROR_MESSAGE;
    }
    throw new Error(errorMessage);
}

export const jobApiService = {
    async retry(jobId) {
        const response = await fetch(`${API_BASE_URL}/jobs/${jobId}/retry`, {
            method: 'POST',
            headers: {
                    'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': apiService.getCsrf(),
            },
        });
        if (!response.ok) {
            await prepareApiError(response);
        }
        return await response.json();
    },
    async retryBatchJob(batchJobId) {
        const response = await fetch(`${API_BASE_URL}/jobs/batch/${batchJobId}/retry`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': apiService.getCsrf(),
            },
        });
        if (!response.ok) {
            await prepareApiError(response);
        }
        return await response.json();
    },
};